const dev2 = {
  aws_project_region: 'us-west-2',
  aws_cognito_identity_pool_id: 'us-west-2:4ffac158-0cf0-46cc-b44a-9dc34560cb33',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_cIknPNxQl',
  aws_user_pools_web_client_id: '63ia3n8t6knkv93fkcrlji79nn',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://cgt5pz2yz5dgzdbwdczhc7txna.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '55f20ae9aa344cc9b6d77aed570bdad8',
  aws_mobile_analytics_app_region: 'us-west-2',
  Analytics: {
    /** MARK: otherwise it raises an error during local development */
    disabled: true,
  },
};

const dev = {
  aws_project_region: 'us-west-2',
  aws_cognito_identity_pool_id: 'us-west-2:c05656cc-fd86-4c89-abe9-2089d2dd6f1e',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_V8I6DuORj',
  aws_user_pools_web_client_id: '1oknn840mu1mopec387e113nr',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://lm5sn3bx2rettnhfy7bd5yuwvy.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '780140a7bd624083914ae1129de1422b',
  aws_mobile_analytics_app_region: 'us-west-2',
  Analytics: {
    /** MARK: otherwise it raises an error during local development */
    disabled: true,
  },
};

const staging = {
  aws_project_region: 'us-west-2',
  aws_cognito_identity_pool_id: 'us-west-2:3d3bf472-49c0-41df-8d88-c7901376e5d3',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_XvLYSOoyi',
  aws_user_pools_web_client_id: '2uubmcv5urv2mu82bj39ubql9r',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://uvcld7x3crdj5pdqxbqhpaq53a.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: 'dfc56eb2bc5b44c58059ca32bae20896',
  aws_mobile_analytics_app_region: 'us-west-2',
  Analytics: {
    /** MARK: otherwise it raises an error during local development */
    disabled: true,
  },
};

const production = {
  aws_project_region: 'us-west-2',
  aws_cognito_identity_pool_id: 'us-west-2:fb6c4db0-eb35-4d3a-9acf-6432a1983f3c',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_YmwGAd3ju',
  aws_user_pools_web_client_id: '6nnvkf9o6f3bcm54t411l4cl4u',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://3w5s6bzgwbgr3jf43uggcmxw3y.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_mobile_analytics_app_id: '994978da01ba49ccb7b1e278c57eac84',
  aws_mobile_analytics_app_region: 'us-west-2',
  Analytics: {
    /** MARK: otherwise it raises an error during local development */
    disabled: true,
  },
};

const envs = { dev2, dev, staging, production };
export default envs;
